import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../../services/User';

const RequireAuth = ({ allowedRoles }: { allowedRoles: string[] }) => {
  const user = getCurrentUser()
  const role = user?.role;
  const location = useLocation()
  
  return (
    user && role && allowedRoles?.includes(role)
      ? <Outlet />
      : user
        ? <Navigate to='/login' state={{ from: location }} replace />
        : <Navigate to='/login' state={{ from: location }} replace />
  );
};

export default RequireAuth;